import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { UserModel } from '../models/user/userModel';
import jwtDecode from 'jwt-decode';

class AuthService {

  getingRefreshToken = false;

  getUser(loginName: string, password: string) {

    let bodyFormData = new FormData();
    bodyFormData.append('loginname', loginName);
    bodyFormData.append('password', password);
    bodyFormData.append('project', "adminstration");

    return axios({
      baseURL: `${Constants.tokenUrl}`,
      url: `${Constants.tokenUrl}`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: bodyFormData
    })
      .then(res => res.data)
      .catch(error =>
        Promise.reject(error)
      )
  }

  createAuthResult = (user: UserModel) => {
    return {
      expiresIn: 60 * 60,
      accessToken: 'accessToken',
      idToken: 'idToken'
    }
  }

  login(userName: string, password: string) {
    return this.getUser(userName, password)
      .then(
        data => {
          if (data.access_token) {
            this.setToken(data)
            return true;
          }
          return false;
        })
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      );
  }

  setToken(authResult) {
    // Saves user token to localStorage    
    localStorage.setItem('id_token', authResult.access_token);
    let expiresAt = JSON.stringify((authResult.expires_in * 1000) + new Date().getTime());
    localStorage.setItem('expires_at', expiresAt);
  }

  getToken() {
    // Retrieves the user token from localStorage    
    return localStorage.getItem('id_token')
  }

  logout = () => {
    // Clear access token and ID token from local storage
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    // navigate to the home route
    //history.replace('/feed');
    //window.location.reload();
  }

  isAuthenticated = () => {
    // Check whether the current time is past the 
    // access token's expiry time
    let expires = localStorage['expires_at'];

    if (expires) {
      let expiresAt = JSON.parse(expires);

      if (new Date().getTime() < expiresAt) {
        // Check and genarates refresh token 30 min before expiration.
        if (new Date().getTime() > (expiresAt - 30 * 60 * 1000)) {
          if (!this.getingRefreshToken) {
            this.getingRefreshToken = true;
            return this.getRefreshToken();
          }
        }
        return true;
      } else {
        return false;
      }
    }

    return false;
  }

  getRefreshToken() {

    let token: any = this.getToken();
    let bodyFormData = new FormData();

    bodyFormData.append('getRefreshToken', 'true');
    bodyFormData.append('loginname', this.getLoginName());
    bodyFormData.append('token', token);

    return axios({
      baseURL: `${Constants.tokenUrl}`,
      url: `${Constants.tokenUrl}`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: bodyFormData
    })
      .then(res => {
        this.getingRefreshToken = false;
        if (res.data.access_token) {
          this.setToken(res.data)
          return true;
        }
        return false;

      })
      .catch(error => {
        return false;
      })
  }

  getProfile() {
    // Using jwt-decode npm package to decode the token
    const token = this.getToken();
    if (token && token !== "undefined") {
      return jwtDecode(token);
    } else {
      return null;
    }
  }

  getUserName() {
    let profile = this.getProfile();
    return profile && profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] ?
      profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] : ''
  }

  getLoginName() {
    let profile = this.getProfile();
    return profile && profile['loginName'] ? profile['loginName'] : ''
  }

  getUserId() {
    let profile = this.getProfile();
    return profile && profile['id'] ? profile['id'] : undefined
  }

  getUserRole() {
    let profile = this.getProfile();
    return profile && profile['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?
      profile['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] : ''
  }

  getUserRegionId() {
    let profile = this.getProfile();
    return profile && profile['regionID'] ? profile['regionID'] : ''
  }

  getUserRegionName() {
    let profile = this.getProfile();
    return profile && profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/locality'] ?
      profile['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/locality'] : ''
  }

  checkIsAdmin = () => {
    if (this.isAuthenticated()) {
      return this.getUserRole() === 'Administrator';
    }
    return false;
  }

  checkIsProductManager = () => {
    if (this.isAuthenticated()) {
      return this.getUserRole() === "ProductManager"
    }
    return false;
  }

  checkIsRegionalManager = () => {
    if (this.isAuthenticated()) {
      return this.getUserRole() === "RegionalManager"
    }
    return false;
  }

  checkIsTrader = () => {
    if (this.isAuthenticated()) {
      return this.getUserRole() === "Trader"
    }
    return false;
  }
}

export default AuthService;